import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isDesignListNeedsRefetch: false,
};

export const designsSlice = createSlice({
  name: 'designs',
  initialState,
  reducers: {
    refetchDesignList: (state, action) => {
      state.isDesignListNeedsRefetch = action.payload;
    },
  },
});

/** Action creators are generated for each case reducer function */
export const { refetchDesignList } = designsSlice.actions;

export default designsSlice.reducer;
